
export
function feconIsacIntegrationStates_configFn ($stateProvider) {
  'ngInject';


  /**
   * Pagin di Login
   */
  $stateProvider
    .state('login', {           // TODO ridefinire il nome dello stato: dev'essere figlio di uno stato che innesta il layout pubblico. ie: external.login
      url: '/login',
      views: {
        '': {                   // TODO indicare il nome della ui-view predisposta nel template dello stato padre per contenere il componente feconIsacPage
          component: 'feconIsacPage'
        }
      },
      resolve: {
        'isacPageLogic': (FeconIsacFacade) => {
          'ngInject';

          return FeconIsacFacade.pageLogic({ funName: 'login' });
        }
      }
    });


  /**
   * Pagina per la forzatura password utilizzando il link ricevuto via email.
   * E' necessario quando l'utente ha effettuato la richiesta di recupero credenziali inviando l'otp per mail.
   */
  $stateProvider
    .state('mail-recovery', {   // TODO ridefinire il nome dello stato: dev'essere figlio di uno stato che innesta il layout pubblico. ie: external.mail-recovery
      url: '/mail-recovery?otp',
      views: {
        '': {                   // TODO indicare il nome della ui-view predisposta nel template dello stato padre per contenere il componente feconIsacPage
        component: 'feconIsacPage'
      }
    },
    resolve: {
      'isacPageLogic': (FeconIsacFacade, $transition$) => {
        'ngInject';

        return FeconIsacFacade.pageLogic({
          funName: 'forceEmail',
          funParams: {
            queryParam_OTP: $transition$.params("to").otp
          }
        });
      }
    }
  });
}



// WEBPACK FOOTER //
// ./client/app/isac-integration/feconIsacIntegration.states.js